import { queryOptions } from "@tanstack/react-query";

import { apiFetch } from "../lib/api";
import type {
  AiBackendResponse,
  RegistryRowsResponse,
  RegistrySlug,
  ScanConfigResponse,
  SystemSetting,
  SystemSettingsResponse,
} from "./types";

export const adminSettingsQueryOptions = queryOptions({
  queryKey: ["admin", "settings"],
  queryFn: () => apiFetch<SystemSettingsResponse>("/admin/settings"),
});

export const adminAiBackendQueryOptions = queryOptions({
  queryKey: ["admin", "ai-backend"],
  queryFn: () => apiFetch<AiBackendResponse>("/admin/ai-backend"),
});

export const adminScanConfigQueryOptions = queryOptions({
  queryKey: ["admin", "scan-config"],
  queryFn: () => apiFetch<ScanConfigResponse>("/admin/scan-config"),
});

export const adminRegistryQueryOptions = (slug: RegistrySlug) =>
  queryOptions({
    queryKey: ["admin", "registry", slug],
    queryFn: () =>
      apiFetch<RegistryRowsResponse>(`/admin/registry/${slug}`),
  });

export function updateSetting(
  key: string,
  value: unknown,
): Promise<SystemSetting> {
  return apiFetch<SystemSetting>(`/admin/settings/${key}`, {
    method: "PUT",
    body: JSON.stringify({ value }),
  });
}
